// extracted by mini-css-extract-plugin
export default {"answerForm":"AnswerForm_answerForm__yeBcH"};